import Api from './baseApi';

export default {
  getCompanies: (params = {}) => {
    let url = '/api/companies';
    if (params.q) url += `?q=${encodeURIComponent(params.q)}`;
    return Api.get(url);
  },
  getCompany: (id) => Api.get(`/api/companies/${id}`),
  postCompany: (model) => Api.post('/api/companies', model),
  putCompany: (id, model) => Api.put(`/api/companies/${id}`, model),
  deleteCompany: (id) => Api.delete(`/api/companies/${id}`),
};

